import { P } from "../../components/Typography";

export const TLLink1 = ({ href, children, target, sx = {} }) => {
  return (
    <P
      component="a"
      href={href}
      // rel="noopener noreferrer" // TODO
      target={target}
      sx={{
        color: "#475467",
        fontWeight: 500,
        textDecoration: "none",
        display: "inline-flex",
        ...sx,
      }}
    >
      {children}
    </P>
  );
};
